"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MarkerIcon = /** @class */ (function () {
    function MarkerIcon(url, size, scaledSize) {
        this.url = url;
        this.size = size;
        this.scaledSize = scaledSize;
    }
    return MarkerIcon;
}());
exports.MarkerIcon = MarkerIcon;
